import { FaTrash, FaBan, FaInbox, FaExclamationTriangle } from "react-icons/fa";

const formatDate = (dateStr) => {
  if (!dateStr) return "";
  const date = new Date(dateStr);
  const now = new Date();
  const isToday = date.toDateString() === now.toDateString();
  if (isToday) {
    return date.toLocaleTimeString("es-PE", { hour: "2-digit", minute: "2-digit" });
  }
  return date.toLocaleDateString("es-PE", { day: "2-digit", month: "short" });
};

const MessageRow = ({ message, accountColor, accountTextColor, accountLabel, accountEmail, isActive, onSelect, onDelete, onMoveMessage, currentFolder = "INBOX", canDelete = true }) => {
  const folder = message?.folder || currentFolder;
  const isInSpam = /spam|junk/i.test(folder || "");
  const isInTrash = /trash|papelera|deleted|eliminad/i.test(folder || "");
  const showReturnToInbox = isInSpam || isInTrash;
  const unread = !message.seen;
  const label = message.mailAccountName || accountLabel;
  const hasAccountLabel = !!label;
  const showAccountEmail = !!accountEmail;

  return (
    <div
      onClick={() => onSelect(message)}
      className={`group flex items-start gap-3 px-4 py-3 cursor-pointer transition-colors border-b border-gray-50
        ${isActive ? "bg-orange-50" : "hover:bg-gray-50"}
        ${unread ? "bg-blue-50/40" : ""}`}
    >
      <div className="flex-shrink-0 mt-0.5">
        <div className={`w-2 h-2 rounded-full mt-1 ${unread ? "bg-orange-500" : "bg-transparent"}`} />
      </div>
      <div className="flex-1 min-w-0">
        <div className="flex items-center justify-between gap-2">
          <span className={`text-xs truncate ${unread ? "font-bold text-gray-900" : "font-medium text-gray-700"}`} title={message.from}>
            {message.from}
          </span>
          <span className="text-[10px] text-gray-400 whitespace-nowrap flex-shrink-0">
            {formatDate(message.date)}
          </span>
        </div>
        <div className="flex items-center gap-1.5 mt-0.5">
          <p className={`text-[11px] truncate ${unread ? "font-semibold text-gray-800" : "text-gray-600"}`}>
            {message.subject || "(Sin asunto)"}
          </p>
          {message.linkAnalysis?.isSuspicious && (
            <span
              className={`inline-flex items-center flex-shrink-0 px-1.5 py-0.5 rounded text-[9px] font-bold gap-0.5 ${
                message.linkAnalysis.riskLevel === "high"
                  ? "bg-red-100 text-red-700"
                  : "bg-amber-100 text-amber-700"
              }`}
              title={`${message.linkAnalysis.flaggedLinks.length} enlace(s) sospechoso(s)`}
            >
              <FaExclamationTriangle className="text-[8px]" />
              {message.linkAnalysis.riskLevel === "high" ? "Peligroso" : "Sospechoso"}
            </span>
          )}
        </div>
        {(hasAccountLabel || showAccountEmail) && (
          <div className="mt-1 flex flex-wrap items-center gap-1.5">
            {hasAccountLabel && (
              <span
                className="inline-flex flex-shrink-0 px-1.5 py-0.5 text-[9px] font-medium rounded"
                style={
                  accountColor
                    ? {
                        backgroundColor: accountColor,
                        color: accountTextColor || "#ffffff",
                      }
                    : { backgroundColor: "#e5e7eb", color: "#4b5563" }
                }
              >
                {label}
              </span>
            )}
            {showAccountEmail && (
              <span className="text-[10px] text-gray-500 truncate min-w-0" title={accountEmail}>
                {accountEmail}
              </span>
            )}
          </div>
        )}
      </div>
      <div className="flex items-center gap-0.5 opacity-0 group-hover:opacity-100 transition-all flex-shrink-0 mt-0.5">
        {onMoveMessage && (
          <button
            onClick={(e) => {
              e.stopPropagation();
              onMoveMessage({ ...message, folder });
            }}
            className={`p-1 rounded ${showReturnToInbox ? "hover:bg-green-50 text-gray-400 hover:text-green-600" : "hover:bg-amber-50 text-gray-400 hover:text-amber-600"}`}
            title={showReturnToInbox ? "Devolver a bandeja de entrada" : "Mover a spam"}
          >
            {showReturnToInbox ? <FaInbox className="text-[10px]" /> : <FaBan className="text-[10px]" />}
          </button>
        )}
        {canDelete && !isInTrash && (
          <button
            onClick={(e) => {
              e.stopPropagation();
              onDelete(message);
            }}
            className="p-1 rounded hover:bg-red-50 text-gray-400 hover:text-red-500"
            title="Mover a papelera"
          >
            <FaTrash className="text-[10px]" />
          </button>
        )}
      </div>
    </div>
  );
};

export default MessageRow;
